import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ContactForm } from '../components/ContactForm';
import axios from 'axios';
import { LocationsMap } from '../components/LocationsMap';
import { Seo } from '../components/Seo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [locations, setLocations] = useState([]);
  const [hero, setHero] = useState(null);
  useEffect(() => {
    axios.get(`${API}/analytics/locations`).then(r => setLocations(r.data)).catch(() => {});
    axios.get(`${API}/page-content/contact_hero`).then(r => setHero(r.data || {})).catch(() => setHero({}));
  }, []);

  return (
    <main className="pt-24 bg-white" data-testid="contact-page">
      <Seo title="Contact" description="Get in touch with NSEC — quote requests, careers, community partnerships, training enquiries. We aim to respond within one working day." path="/contact" />
      {/* Hero Section */}
      <section className="py-16 lg:py-24 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            // Hide until CMS payload arrives so we never flash defaults
            // when an admin has customised the copy.
            style={{ visibility: hero === null ? 'hidden' : 'visible' }}
          >
            <p className="accent-font text-lime-600 mb-4" data-testid="contact-hero-overline">{hero?.overline || 'Get In Touch'}</p>
            <h1 className="font-outfit font-bold text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight mb-6" data-testid="contact-hero-heading">
              {hero?.heading || 'Contact'}{(hero?.heading_highlight || 'Us') && (<> <span className="text-lime-600">{hero?.heading_highlight || 'Us'}</span></>)}{hero?.heading_suffix ? ` ${hero.heading_suffix}` : ''}
            </h1>
            <p className="text-neutral-600 text-lg max-w-3xl" data-testid="contact-hero-description">
              {hero?.description || "Ready to discuss your waste management needs? We're here to help. Get in touch with our friendly team today."}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm isFullPage={true} />

      {/* Our Locations */}
      {locations.length > 0 && (
        <section className="py-16 lg:py-24 bg-neutral-50" data-testid="contact-locations-section">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <p className="accent-font text-lime-600 mb-4">Our Locations</p>
              <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-neutral-900 tracking-tight">
                Where to <span className="text-lime-600">Find Us</span>
              </h2>
            </motion.div>

            <LocationsMap
              locations={locations}
              mapTestId="contact-locations-map"
              cardTestIdPrefix="contact-location-card"
            />
          </div>
        </section>
      )}
    </main>
  );
}
